/**
 * @Description 男女比例图
 */

import { FC } from 'react';
import styles from './index.module.less';
import { IconFont } from '@/components';

const GenderRate:FC<any> = ({
  title,
  value,
  femaleValue,
  showLable
}) => {
  return (
    <div className={styles['rate']}>
      <div className={styles['title']}>{title}</div>

      <div className={styles['content']}>

        <div className={styles['boy']}>
          <IconFont iconHref='iconic_boy' className={styles['boy-icon']}/>
          {showLable ? <div className={styles['boy-label']}>男性</div> : <></>}
        </div>

        <div className={styles['progress-box']}>
          <progress max={100} value={value} className={styles['progress']}/>

          <div className={styles['divider']} style={{ left: `${544 * (value / 100)}px` }}/>

          <div className={styles['percent']} style={{ width: `${544 * (value / 100)}px` }}>
            {`${value}%`}
          </div>

          <div className={styles['percent']} style={{ width: `${544 * (femaleValue / 100)}px`, left: `${544 * (value / 100)}px` }}>
            {`${femaleValue}%`}
          </div>
        </div>

        <div className={styles['girl']}>
          <IconFont iconHref='iconic_girl' className={styles['girl-icon']}/>
          {showLable ? <div className={styles['girl-label']}>女性</div> : <></>}
        </div>
      </div>
    </div>
  );
};

export default GenderRate;
